'use client';

import Typography from '@mui/material/Typography';
import MLink from '@mui/material/Link';
import { buildTitle } from '@/utils/layout';
import config from '@/config';
import Main from '@/components/main';
import { DISCORD_ENABLED } from '@/constants/DISCORD_ENABLED';
import { DISCORD_INVITE_URL } from '@/constants/DISCORD_INVITE_URL';

const Contact = () => {
  return (
    <Main compact>
      <title>{buildTitle('Contact')}</title>
      <link rel="canonical" href={`${config().universal.baseUri}/contact`} />
      <Typography variant="h1">Contact</Typography>
      <p>
        Please
        {' '}
        <MLink href="mailto:support@everydayrides.com">reach out via email</MLink>
        {' '}
        if you have any questions, feedback, or want to get in touch.
      </p>
      {DISCORD_ENABLED && (
        <p>
          You can also
          {' '}
          <MLink href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer">
            join the Everyday Rides Discord
          </MLink>
          {' '}
          for help, announcements, and event notifications.
        </p>
      )}
    </Main>
  );
};

export default Contact;
